<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-lg-6">
            <div class="card">
              <div class="card-body">
                <div class="form-group">
                  <label class="control-label">Tingkat Sekolah</label>
                  <multiselect v-model="tingkat_sekolah"
                               :options="tingkat_sekolahs"
                               track-by="id"
                               label="name"
                  ></multiselect>
                </div>
                <div class="form-group">
                  <label for="materiname">Name</label>
                  <input id="materiname" v-model="payload.name" name="materiname" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <label for="materimapelid">Mapel ID</label>
                  <input
                      id="materimapelid"
                      v-model="payload.mapel_id"
                      name="materimapelid"
                      type="text"
                      class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card">
              <div class="card-body">
                <div id="tickets-table_filter" class="dataTables_filter text-md-left">
                  <label  class="d-inline-flex align-items-center">

                    <b-form-input
                        id="searchmapel"
                        name="searchmapel"
                        v-model="searchMapelName"
                        type="search"
                        placeholder="cari mapel ..."
                        @change="searchMapel"
                        class="form-control form-control-sm ml-6"
                    ></b-form-input>
                  </label>
                </div>
                <b-form-group>
                  <b-form-radio
                      v-model="payload.mapel_id"
                      v-for="data in listMapel" :key="data.id"
                      class="custom-radio mb-3"
                      :value="data.id"
                  >{{data.name}}</b-form-radio>

                </b-form-group>
                <div class="form-group">

                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary mr-1" @click="saveData">Save Changes</button>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Multiselect from 'vue-multiselect'

import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Vue from "vue";

export default {
  name: "form.vue",
  page: {
    title: "Add Tujuan Pembelajaran",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Multiselect, Layout, PageHeader },
  data() {
    return {
      title: 'Add Tujuan Pembelajaran',
      items: [
        {
          text: 'Tujuan Pembelajaran',
          href: '/',
        },
        {
          text: 'Add Tujuan Pembelajaran',
          active: true,
        },
      ],
      searchMapelName: '',
      payload: { "name": "", "mapel_id": 0, "tingkat_sekolah_id": 0 },
      tingkat_sekolahs:[
        {id: 0, name: 'TK'},
        {id: 1, name: 'SD-1'},
        {id: 2, name: 'SD-2'},
        {id: 3, name: 'SD-3'},
        {id: 4, name: 'SD-4'},
        {id: 5, name: 'SD-5'},
        {id: 6, name: 'SD-6'},
        {id: 7, name: 'SMP-7'},
        {id: 8, name: 'SMP-8'},
        {id: 9, name: 'SMP-9'},
        {id: 10, name: 'SMA-10'},
        {id: 11, name: 'SMA-11'},
        {id: 12, name: 'SMA-12'},
      ],
      tingkat_sekolah: {
        id: 0,
        name: ''
      },
      listMapel: []
    }
  },
  methods:{
    loadData(idForm){
      this.stillLoading = true
      this.$store.dispatch(
          'tujuanpembelajaran/GET_TUJUAN_PEMBELAJARAN', idForm
      ).then((resp) => {
        if (resp.data.code==200){
          this.notFound = false
          let temp=this.$store.getters['tujuanpembelajaran/tujuan_pembelajaran']
          this.payload = temp.data
          this.tingkat_sekolah = this.tingkat_sekolahs.find(x => x.id === this.payload.tingkat_sekolah_id)
          this.notFound = false
        } else {
          this.warningmessage();
        }
      }).catch(function () {

      })
      this.stillLoading = false
    },
    saveData(){
      this.payload.tingkat_sekolah_id = this.tingkat_sekolah.id
      if ( this.$route.meta.mode=='edit' ){
        this.$store.dispatch(
            'tujuanpembelajaran/PUT_TUJUAN_PEMBELAJARAN', this.payload
        ).then(() => {
          this.successmsg()
          this.$router.push('/tujuan_pembelajaran')
        }).catch(function () {
          this.warningmessage('Failed to save')
        })

      } else {
        this.$store.dispatch(
            'tujuanpembelajaran/POST_TUJUAN_PEMBELAJARAN', this.payload
        ).then(() => {
          this.successmsg()
          this.$router.push('/tujuan_pembelajaran')
        }).catch(function () {
          this.warningmsg('Failed to save')
        })
      }
    },
    searchMapel(){
      if (this.searchMapelName==''){
        this.listMapel = []
      } else {
        let paramsTemp = queryString.stringify({
              ...{
                name: this.searchMapelName,
                sort: 'name',
                page: 1,
                limit: 100
              }
              , ...this.options
            }
        )
        // this.stillLoading=true
        this.$store.dispatch(
            'mapel/GET_MAPELS', {masterType: this.$route.meta.name, params: paramsTemp}
        ).then(() => {

          this.stillLoading = false
          // return tableData
          this.listMapel = (this.$store.getters['mapel/mapels']) ? this.$store.getters['mapel/mapels'] : []
        }).catch(function () {
          // this.stillLoading=false
          this.listMapel = []
        })
      }
    },
    successmsg() {
      Vue.swal({
        position: "top-end",
        icon: "success",
        title: "Your data has been saved",
        showConfirmButton: false,
        timer: 1500
      });
    },
    warningmsg(text) {
      Vue.swal({
        position: "top-end",
        icon: "warning",
        title: text,
        showConfirmButton: false,
        timer: 1500
      });
    },
  },
  mounted() {
    if (this.$route.meta.mode=='edit'){
      this.notFound = true
      this.loadData(this.$route.params.id)
    }
  },
}
</script>

<style scoped>

</style>